import { CommonModule } from '@angular/common';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { FormsModule } from '@angular/forms';
import { ChatService } from '../../../services/chat.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-chatlink-popup',
  templateUrl: './chatlink-popup.component.html',
  styleUrls: ['./chatlink-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ClipboardModule, MatIconModule],
})
export class ChatlinkPopupComponent implements OnInit {
  @Input() chatLink: string = '';
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  ngOnInit() {}

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  onCloseClick() {
    this.onClose.emit();
  }
}
